export default __webpack_public_path__ + "static/media/More.e18f2ab5.svg";